export var RequestKind;
(function (RequestKind) {
    RequestKind[RequestKind["Start"] = 0] = "Start";
    RequestKind[RequestKind["Script"] = 1] = "Script";
    RequestKind[RequestKind["Shape"] = 2] = "Shape";
})(RequestKind || (RequestKind = {}));
var ScriptRequest = /** @class */ (function () {
    function ScriptRequest(script) {
        this.script = script;
        this.kind = RequestKind.Script;
    }
    return ScriptRequest;
}());
export { ScriptRequest };
export var RenderMode;
(function (RenderMode) {
    RenderMode[RenderMode["Bitmap"] = 0] = "Bitmap";
    RenderMode[RenderMode["Heightmap"] = 1] = "Heightmap";
    RenderMode[RenderMode["Normals"] = 2] = "Normals";
})(RenderMode || (RenderMode = {}));
var RenderRequest = /** @class */ (function () {
    function RenderRequest(tape, camera, depth, mode, cancel_token_ptr) {
        this.tape = tape;
        this.kind = RequestKind.Shape;
        this.camera = camera.camera.serialize();
        this.depth = depth;
        this.mode = mode;
        this.cancel_token_ptr = cancel_token_ptr;
    }
    return RenderRequest;
}());
export { RenderRequest };
var StartRequest = /** @class */ (function () {
    function StartRequest(init) {
        this.init = init;
        this.kind = RequestKind.Start;
    }
    return StartRequest;
}());
export { StartRequest };
////////////////////////////////////////////////////////////////////////////////
export var ResponseKind;
(function (ResponseKind) {
    ResponseKind[ResponseKind["Started"] = 0] = "Started";
    ResponseKind[ResponseKind["Script"] = 1] = "Script";
    ResponseKind[ResponseKind["Image"] = 2] = "Image";
    ResponseKind[ResponseKind["Cancelled"] = 3] = "Cancelled";
})(ResponseKind || (ResponseKind = {}));
var StartedResponse = /** @class */ (function () {
    function StartedResponse() {
        this.kind = ResponseKind.Started;
    }
    return StartedResponse;
}());
export { StartedResponse };
var ScriptResponse = /** @class */ (function () {
    function ScriptResponse(output, tape) {
        this.output = output;
        this.tape = tape;
        this.kind = ResponseKind.Script;
    }
    return ScriptResponse;
}());
export { ScriptResponse };
var ImageResponse = /** @class */ (function () {
    function ImageResponse(data, depth) {
        this.data = data;
        this.depth = depth;
        this.kind = ResponseKind.Image;
    }
    return ImageResponse;
}());
export { ImageResponse };
var CancelledResponse = /** @class */ (function () {
    function CancelledResponse() {
        this.kind = ResponseKind.Cancelled;
    }
    return CancelledResponse;
}());
export { CancelledResponse };
